import { createRouteRef } from '@backstage/frontend-plugin-api';
export const rootRouteRef = createRouteRef();
export const governanceRouteRef = createRouteRef();
export const iamRouteRef = createRouteRef();
export const projectsRouteRef = createRouteRef();
export const operationsRouteRef = createRouteRef();
export const monitoringRouteRef = createRouteRef();
export const documentationRouteRef = createRouteRef();
export const automationRouteRef = createRouteRef();
export const analyticsRouteRef = createRouteRef();
export const administrationRouteRef = createRouteRef();
